import React from 'react';
import { Modal } from '../ui/Modal';
import { useTranslation } from '../../translations';
import CameraScanner from './CameraScanner';

// „Skanuj aparatem" — panel otwarty na telefonie albo tablecie z kamerą. Okno zostaje otwarte
// między skanami (seria sztuk przy wydaniu), zamyka je dopiero użytkownik.
export default function CameraScanModal({ open, onClose, onScan, title }) {
  const { t } = useTranslation();
  return (
    <Modal
      open={open}
      onClose={onClose}
      title={title || t('scanner.cameraTitle')}
      subtitle={t('scanner.cameraSubtitle')}
      size="sm"
      data-cy="camera-scan-modal"
      // Otwierane także z WNĘTRZA szczegółów rezerwacji (nakładka na --z-modal): zwykła warstwa
      // położyłaby tło pod tamtą nakładką, a klik obok zamykałby rezerwację zamiast skanera.
      elevated
    >
      {open && <CameraScanner onCode={onScan} active={open} />}
    </Modal>
  );
}
